module.exports = __webpack_public_path__ + "static/media/role-box-image.96b13858.svg";